export const SEARCH = 'SEARCH/USER';
export const LOADING_STATUS = 'SEARCH/LOADING';
